import React from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { useTranslation } from "react-i18next";

const QuizSuccessModal = (props) => {
  const { t } = useTranslation();
  return (
    <Modal
      center
      open={props?.open}
      closeOnOverlayClick={false}
      closeOnEsc={false}
      showCloseIcon={false}
      classNames={{ modal: "success-modal", root: "modal-own-wrapper" }}
    >
      <div className="settings-wrapper mx-auto">
        <div className="stripe border-bottom heading-wrapper">
          <div className="d-flex justify-content-center">
            <img
              alt="..."
              src="/assets/icons/quizSuccess.png"
            />
          </div>
          <p className="h4 font-weight-bold text-center terms-head">
            {t("user.quizSuccess.congratulations")}
          </p>
        </div>
        <div className="mx-lg-3 text-justify p-3 terms-text">
          {props?.message?.length > 0 ?
            <>
              <p className="font-weight-normal" dangerouslySetInnerHTML={{__html: props?.message}}></p>
            </> :
            <>
              <p className="font-weight-normal">
                {t("user.quizSuccess.completedQuiz")}
              </p>
              <p className="font-weight-normal">
                {t("user.quizSuccess.venueAccess")}
              </p>
              <p className="font-weight-normal">
                {t("user.quizSuccess.scanQR")}
              </p>
              <p className="font-weight-normal">
                {t("user.quizSuccess.contactSupport")}
              </p>
              <p className="font-weight-normal">
                {t("user.quizSuccess.condomNote")}
              </p>

            </>

          }
        </div>
        <div className="stripe pt-3 border-top">
          <div className="col-md-12 text-center">
            <button
              className="btnFooter footer-width py-2 px-2"
              onClick={() => props?.closeModal()}
            >
              {t("user.quizSuccess.continueButton")}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default QuizSuccessModal;
